export default __webpack_public_path__ + "static/media/xylem_logo.6e37478c.svg";